import { render } from "./SearchServices.vue?vue&type=template&id=166e7879&scoped=true"
import script from "./SearchServices.vue?vue&type=script&lang=js"
export * from "./SearchServices.vue?vue&type=script&lang=js"

import "./SearchServices.vue?vue&type=style&index=0&id=166e7879&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-166e7879"

export default script